export default class Person {
    type: string;
    name: string;
    surname: string;
    gender: string;
    birthDate: string;
    isBilling: boolean;
    preferences: BookingTravelersPreferences;

    private meals: any = {
        no_special_meal: 'No special meal',
        vegetarian: 'Vegetarian',
        vegan: 'Vegan',
        gluten_free: 'Gluten free',
        kosher: 'Kosher',
        other: 'Other (specified in notes)',
    };
    private seats: any = {
        aisle: 'Aisle',
        window: 'Window'
    };
    private genders: any = {
        male: 'Male',
        female: 'Female'
    };
    private types: any = {
        A: 'Adult',
        ADT: 'Adult',
        C: 'Child',
        CHD: 'Child',
        I: 'Infant',
        INF: 'Infant'
    };

    constructor(type: string = 'A') {
        this.type = type;
        this.name = '';
        this.surname = '';
        this.gender = '';
        this.birthDate = '';
        this.isBilling = false;
        this.preferences = {
            frequent_flyer_numbers: '',
            tsa_pre_check: '',
            seat_assignments: '',
            meal_request: '',
            include_baggage: false,
            notes: '',
        }
    }

    public mealName(meal: string) {
        return typeof (this.meals[meal]) !== 'undefined' ? this.meals[meal] : '';
    }

    public seatName(seat: string) {
        return typeof (this.seats[seat]) !== 'undefined' ? this.seats[seat] : '';
    }

    public genderName(gender: string) {
        return typeof (this.genders[gender]) !== 'undefined' ? this.genders[gender] : '';
    }

    public typeName(type: string) {
        return typeof (this.types[type]) !== 'undefined' ? this.types[type] : '';
    }


}

export interface BookingTravelersPreferences {
    frequent_flyer_numbers: string,
    tsa_pre_check: string,
    seat_assignments: string,
    meal_request: string,
    include_baggage: boolean,
    notes: string,
}